module.exports = __webpack_public_path__ + "r-v3/img/lock.40cf3bc3.svg";